import { Pipe, PipeTransform } from '@angular/core';
import { Usage } from '../../../api/models';

@Pipe({
  name: 'findCustomerUsage'
})
export class FindCustomerUsagePipe implements PipeTransform {

  transform(customerId: number, customerUsages: Usage[]): any {
    return customerUsages.find(customerUsage => customerUsage.customerId === customerId)
  }

}
